var exports = {
  "t$": "stack__hEglTX",
  "zr": "root__k3xew1",
  "R_": "heading__XHZ0oZ",
  "DD": "title__3Lrt0w",
  "fV": "subheading__o_UtPl",
  "xf": "inheritColor__ObYoz0",
  "x5": "labelBorder__a2cPZy",
  "JU": "labelWrap__bAld2D",
  "Pf": "label__E2xSwe",
  "Yo": "cells__XHeMKn",
};

module.exports = exports;
